// extracted by mini-css-extract-plugin
export default {"buttonContainer":"nextbutton_buttonContainer__d7I8Q"};